__turbopack_context__.v({
  "dot": "TierCampaignChip-module__T3BrIG__dot",
  "spotsLeft": "TierCampaignChip-module__T3BrIG__spotsLeft",
  "strikethroughPrice": "TierCampaignChip-module__T3BrIG__strikethroughPrice",
  "tierText": "TierCampaignChip-module__T3BrIG__tierText",
  "wrapper": "TierCampaignChip-module__T3BrIG__wrapper",
});
